<template>
  <div
    class="opple-ota-cards"
  >
    <div
      v-if="type === 2 && !tianMu"
      class="opple-ota-cards_head"
    >
      <div class="opple-ota-cards_head_lt">
        <i class="el-icon-warning-outline" />
        {{ $t('deviceMsg.morefirmwaretip') }}
      </div>
    </div>
    <OtaBind
      v-if="isSupportBindOta"
      :version-list="versionList"
      :device-model="deviceModel"
      :ota-upgrade-type-list="(firmwareVersion && firmwareVersion.OtaUpgradeTypeList) || []"
      :is-disabled-guide="otaBoot && !isCheckGuide"
      @otaSuccess="otaSuccess"
    />
    <div
      v-if="!isSupportBindOta"
      class="opple-ota-cards_container"
    >
      <component
        :is="shouldUseAsyncCard ? 'AsyncOtaCard' : 'SingleCard'"
        v-for="(item, index) in versionList"
        :ref="`singleCard${index}`"
        :key="index"
        :device-model="deviceModel"
        :info="item"
        :type="type"
        :tian-mu="tianMu"
        :show-key-up="showKeyUp"
        :ota-status="otaStatus"
        :up-ota-index="index"
        :is-disabled-guide="isImmediateGuideDisabled"
        :is-loading-req-cancel-ota="isLoadingReqCancelOta"
        :is-loading-req-ota="isLoadingReqOta"
        :is-show-ota-btn="true"
        :card-index="index"
        @startOta="onRequestOta"
        @startImmediateOta="onRequestImmediateOta"
        @startAutoOta="onRequestAutoOta"
        @stopOta="onRequestCancelOta"
        @showUpLevelBtn="showUpLevelBtn"
      />
    </div>
    <div
      class="opple-ota-cards_guide"
    >
      <panelBoot
        v-show="shouldShowPanelBoot"
        :device-only="deviceOnly"
        :classsku="deviceModel.ClassSku"
        :panel-boot-checked="isCheckGuide"
        @handleChecked="handlePanelBootChecke"
      />
    </div>
  </div>
</template>
<script>
import panelBoot from '@/components/common/panelBoot.vue'
import SingleCard from './SingleCard.vue';
import AsyncOtaCard from './AsyncOtaCard.vue';
import { parseVersionName } from '@/utils/parseVersionName.js'
import {
  BatchSearchFirmwareVersion,
  GetFirmwareVersionFromDevice,
  StartOta,
  StartCombineOta,
  StopOta,
  GetDeviceSupportFunctions,
  GetDeviceStatus
} from '@/axios/IDevice.js'
import sleep from '@utils/sleep'
import { alerterror, success, warning ,error } from '@/assets/js/common.js'
import { OTAUpgradeType } from '@/enums/device'
import { postWebIOSocket } from '@assets/socket'
import OtaBind from './OtaBind.vue';
import { OTA_STATUS_ENUMS,WIFI_STATUS_ENUMS } from './enums';

export default {
  components: { 
    SingleCard,
    AsyncOtaCard,
    panelBoot,
    OtaBind
  },
  props: {
    deviceOnly: {
      type: Boolean,
      default: false
    },
    // firmwareVersion: {
    //   type: Object,
    //   default: () => {
    //     return {
    //     }
    //   }
    // },
    otaBoot: {
      type: Boolean,
      default: false
    },
    device: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
    deviceModel: {
      type: Object,
      default: () => {
        return {
          }
      }
    },
    actionList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isRemoveSocket: {
      type: Boolean,
      default: true
    },

    //是否天幕ota
    tianMu:{
      type:Boolean,
      default:false
    },
    // 天幕ota是否显示升级按钮
    showKeyUp: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isSupportBindOta: false,
      isShowGuide: false,
      isCheckGuide: false,
      isLoadingReqOta: false,
      isLoadingReqCancelOta: false,
      firmwareVersion: [],
      versionList: [],
      upOtaIndex: -1,
      type: 1, // 0: 无法升级的 1:单卡片 2:多卡片
      // isstop: false,
      // progress: 0,
      // otaInfo: ''
      isSupportAsyncOta: false, // 支持异步升级
      isLEGattOtaDevice: false, // 低功耗 LEGATT（仅对外上报，不参与异步分支判断）
      isDeviceAwake: true,
      otaSuccessHandled: false,
    }
  },

  computed: {
    showOtaBind() {
      // 多固件升级暂未启用；与异步升级不互斥，后续启用时勿再排除 useAsyncOtaUi
      return false;
    },
    /** 网关设备（ChildCategoryType === 1）不走异步升级 UI */
    isGatewayDevice() {
      const childCategoryType = this.deviceModel?.ChildCategoryType ?? this.device?.ChildCategoryType;
      return Number(childCategoryType) === 1;
    },
    /** 设备支持异步升级时走异步 OTA 卡片（网关已在 isSupportAsyncOta 中排除） */
    useAsyncOtaUi() {
      return this.isSupportAsyncOta;
    },
    // 支持异步升级且睡眠态展示双按钮卡片；唤醒态回退单按钮
    shouldUseAsyncCard() {
      return this.useAsyncOtaUi && !this.isDeviceAwake;
    },
    socketmodel() {
      return this.$store.state.socketmodel //需要监听的数据
    },
    otaStatus() {
      // 最后展示进行中
      const isHasProcessing = this.versionList.some(item => {
        return item.otaStatus === OTA_STATUS_ENUMS.PROCESSING;
      });

      if (isHasProcessing) {
        return OTA_STATUS_ENUMS.PROCESSING;
      }

      // 其次展示停止
      const isHasStop = this.versionList.some(item => {
        return item.otaStatus === OTA_STATUS_ENUMS.STOP;
      });

      if (isHasStop) {
        return OTA_STATUS_ENUMS.STOP;
      }

      // // 优先展示错误
      // const isHasFailed = this.versionList.some(item => {
      //   return item.otaStatus === OTA_STATUS_ENUMS.FAILED;
      // });

      // if (isHasFailed) {
      //   return OTA_STATUS_ENUMS.FAILED;
      // }

      // 其余一律为待机
      return OTA_STATUS_ENUMS.PADDING
    },
    wifiValueTypeItem(){
      for (let i = 0; i < this.actionList.length; i++) {
          const actionList = this.actionList[i].ActionList;
          for (let j = 0; j < actionList.length; j++) {
              const values = actionList[j].Values;
              for (let k = 0; k < values.length; k++) {
                  const value = values[k];
                  if (value.ValueType === 'UIControl_WiFiStatus') {
                      return value;
                  }
              }
          }
      }
      return null;
    },
    shouldShowPanelBoot() {
      if (this.tianMu) return false;
      // 有 DEVICE_LOCAL 升级引导即展示，与睡眠态无关
      return this.otaBoot;
    },
    isImmediateGuideDisabled() {
      // panelBoot 展示且非设备端确认场景时，要求先完成网页引导勾选
      return this.shouldShowPanelBoot && !this.deviceOnly && !this.isCheckGuide;
    },
  },

  watch: {
    socketmodel (res) {
      this.handlerSocket(res);
    },
  },

  mounted() {
    this.init();
  },
  beforeDestroy() {
    if (this.isRemoveSocket === false) return;

    this.removeSocket();
  },

  methods: {
    handlePanelBootChecke(val){
      if(this.wifiValueTypeItem){
        const wifiStatus = this.device.StatusInfo.filter(item=>item.StatusType === this.wifiValueTypeItem.Type)[0].Value1
        //含有WiFi的设备
        const message = this.wifiValueTypeItem&&this.wifiValueTypeItem?.EnumValue.filter(item=>item.Value == wifiStatus )
  
        if(+wifiStatus === WIFI_STATUS_ENUMS.ONLINE){
          this.isCheckGuide = val
        }else{
          warning(this,`WIFI ${message&&message[0].Name}` );
        }
      }else{
        this.isCheckGuide = val
      }
    },
    async init() {
      await this.GetDeviceSupportCombineOtaOrAsyncOta();
      this.doOTAVersion(true);
      this.dosocketaction();
    },

    async GetDeviceSupportCombineOtaOrAsyncOta() {
      try {
        const res = await GetDeviceSupportFunctions({
          VDeviceIds: [this.device.VDeviceId],
          FunctionTypes: ['AsyncOta', 'SupportCombineOta'],
        });

        const asyncInfo = (res.Result?.AsyncOta || [])[0] || {};
        const combineInfo = (res.Result?.SupportCombineOta || [])[0] || {};
        const { GatewaySupport, parentDeviceSupport, DeviceSupport } = asyncInfo;
        const {
          GatewaySupport: GatewaySupport2,
          parentDeviceSupport: parentDeviceSupport2,
          DeviceSupport: DeviceSupport2,
        } = combineInfo;

        // 接口可能给网关勾上异步能力，但网关实际不走异步升级路线
        const hasAsyncCapability = !!GatewaySupport && !!parentDeviceSupport && !!DeviceSupport;
        this.isSupportAsyncOta = hasAsyncCapability && !this.isGatewayDevice;
        this.isSupportBindOta = !!GatewaySupport2 && !!parentDeviceSupport2 && !!DeviceSupport2;
        console.log('isSupportAsyncOta', this.isSupportAsyncOta, 'isGatewayDevice', this.isGatewayDevice);
      } catch (err) {
        console.log('error', err);
      }
    },

    /** 查询ota */
    async doOTAVersion(isFirstInit) {
      let para = { 
        vDeviceId: this.device.VDeviceId, 
        searchIp: false 
      };

      this.doBatchSearchFirmwareVersion(para, isFirstInit);

      const res = await GetFirmwareVersionFromDevice(para, 1);

      if (
        res.StatusCode == this.$store.state.rightStatusCode && 
        !!res.Result.IP
      ) {
       this.$emit('updateLocalIp', res.Result.IP || '');
      }
    },

    /* 
     * 获得设备版本号 接口返回处理
     * res:接口返回数据包 (集成)
     */
    async doBatchSearchFirmwareVersion (para, isFirstInit) {
      const res = await BatchSearchFirmwareVersion(para);

      if (
        res.StatusCode !== this.$store.state.rightStatusCode || 
        !res.Result
      ) return;

      const Result = { ...(res.Result || {})};
      const VersionList = (res.Result.VersionList || []).slice();
      const LocalFirmwareVersionList = res.Result.LocalFirmwareVersionList || [];
      const IpFieldCode = res.Result.IpFieldCode || null;
  
      // 获取VersionList中每个条目的SourceType
      const sourceTypesInVersionList = VersionList.map(item => item.SourceType);
    
      // 遍历 LocalFirmwareVersionList 检查匹配和补全
      LocalFirmwareVersionList.forEach(item => {
        if (!sourceTypesInVersionList.includes(item.SourceType)) {
          // 补全缺失的 SourceType
          VersionList.push({
            FileUrl: '', 
            SourceType: item.SourceType,
            LocalVersion: item.Version, 
            LatestedVersion: 0, 
            Mac: null
          });
        }
      });
      // 低功耗设备判断（仅对外上报）
      const otaTypeList = Result.OtaUpgradeTypeList || [];
      this.isLEGattOtaDevice = otaTypeList.some(item => {
        const supportType = Number(item.SupportType) || 0;
        return (supportType & OTAUpgradeType.LEGATT) === OTAUpgradeType.LEGATT;
      });
      this.$emit('updateLEGattValue', this.isLEGattOtaDevice);

      VersionList.sort((a, b)=>{
        return a.SourceType - b.SourceType
      })

      this.syncParentOtaState(Result, VersionList);

      let ache = JSON.parse(
        getLocalStoragItem('upOtaDeviceInfo') || '{}'
      )

      if (isFirstInit) {
        VersionList.forEach((item, index) => {
        // let isloadingota = false;
          if (
            !!ache && 
            this.device.VDeviceId === ache.VDeviceId && 
            index === ache.upOtaIndex
          ) {
            this.upOtaIndex = ache.upOtaIndex;
          } else {
            // 准备升级
            item.otaStatus = OTA_STATUS_ENUMS.PADDING;
            item.hasError = false;
            item.otaInfo = '';
          }
        });
      }

      this.firmwareVersion = {
        ...Result,
        CloudVersion: Result.LatestedVersion,
        VersionList,
      };

      if (IpFieldCode !== null) {
        this.$emit('updateIpFieldCode', IpFieldCode);
      }

      this.updateVersionList();

      if (this.isSupportAsyncOta) {
        await this.refreshDeviceAwakeState();
      }
    },

    /** 同步父组件 deviceMsg 仍依赖的 OTA 元数据（版本查询统一在子组件完成） */
    syncParentOtaState(Result, VersionList) {
      const otaTypeList = Result.OtaUpgradeTypeList || [];
      const hasDeviceLocal = otaTypeList.some(item => {
        const supportType = Number(item.SupportType) || 0;
        return (supportType & OTAUpgradeType.DEVICE_LOCAL) === OTAUpgradeType.DEVICE_LOCAL;
      });
      //this.$emit('updateOtaBoot', hasDeviceLocal);
      this.$emit('updateDeviceOnly', hasDeviceLocal);

      const parentFirmwareVersion = {
        ...Result,
        CloudVersion: Result.LatestedVersion,
        VersionList: VersionList.map(item => ({ ...item })),
      };
      const cache = JSON.parse(getLocalStoragItem('upOtaDeviceInfo') || '{}');
      parentFirmwareVersion.VersionList.forEach((item, index) => {
        item.isloadingota = true;
        if (
          cache &&
          this.device.VDeviceId === cache.VDeviceId &&
          index === cache.upOtaIndex
        ) {
          item.isloadingota = false;
        }
        item.isStop = false;
      });
      this.$emit('updateFirmwareVersion', parentFirmwareVersion);
    },

    updateVersionList() {
      const lastVersionList = this.versionList || [];
      const { firmwareVersion } = this;

      if (!firmwareVersion) return;

      const LocalFirmwareVersionList = firmwareVersion.LocalFirmwareVersionList || [];
      const VersionList = firmwareVersion.VersionList || [];
      if (LocalFirmwareVersionList.length === 0) {
        this.type = 0;

        VersionList.push({
          FileUrl: '', 
          SourceType: 0,
          LocalVersion: this.firmwareVersion.LocalVersion, 
          CloudVersion: this.firmwareVersion.CloudVersion,
          LatestedVersion: this.firmwareVersion.CloudVersion,
        });
      } else if (
        LocalFirmwareVersionList.length === 1
      ) {
        this.type = 1;
        this.upOtaIndex = 0;
      } else {
        this.type = 2;
      }

      this.versionList = VersionList.map((item, i) => {
        const LocalVersion = parseVersionName(item.LocalVersion);
        const LatestedVersion = parseVersionName(item.LatestedVersion);
        const isLasted = LocalVersion === LatestedVersion;
        let otaStatus = OTA_STATUS_ENUMS.PADDING;
        let otaInfo = '';
        let progress = 0;

        if (lastVersionList.length) {
          otaStatus = lastVersionList[i]?.otaStatus;
          otaInfo = lastVersionList[i]?.otaInfo;
          progress = lastVersionList[i]?.progress;
        }
        console.log('otaStatus', LocalVersion, LatestedVersion, new Date());
        return {
          ...item,
          isLasted,
          LatestedVersion,
          LocalVersion,
          otaStatus,
          otaInfo,
          progress
        }
      });

      // firmwareVersion['LocalFirmwareVersionList'] != null && firmwareVersion['LocalFirmwareVersionList'].length == 1 
      console.log('mounted', this.versionList, VersionList);
    },

    /**
     * 设置当前固件
     * @param data 
     */
    setCurrentFirmware(data) {
      if (!this.versionList[this.upOtaIndex]) return;

      this.versionList[this.upOtaIndex] = {
        ...this.versionList[this.upOtaIndex],
        ...data
      }
    // console.log('更新进度', this.versionList[this.upOtaIndex]); 拷贝是为了触发 Vue2 的响应式更新。

      this.versionList = this.versionList.slice();
    },

    /**
     * 请求ota
     * @param upOtaIndex 
     */
     async onRequestOta(upOtaIndex) {
      // 过界或者进行中
      if (!this.versionList[upOtaIndex]){
        console.error('onRequestOta index error')
        return
      };
      const {otaStatus} = this.versionList[upOtaIndex]
      if(otaStatus === OTA_STATUS_ENUMS.PROCESSING) return

      this.otaSuccessHandled = false;

      const params = { 
        vDeviceId: this.deviceModel.VDeviceId, 
        mode: 0,
        SourceType: this.versionList[upOtaIndex].SourceType,
      };

      this.isLoadingReqOta = true;

      const res = await StartOta(params);

      this.isLoadingReqOta = false;

      if (res.StatusCode !== this.$store.state.rightStatusCode) {
        alerterror(this, res.StatusCode);

        return;
      };

      this.upOtaIndex = upOtaIndex;

      let ache = {
        VDeviceId: this.deviceModel.VDeviceId,
        upOtaIndex: upOtaIndex
      }

      setLocalStoragItem('upOtaDeviceInfo', JSON.stringify(ache));

      this.setCurrentFirmware({
        otaStatus: OTA_STATUS_ENUMS.PROCESSING,
        otaInfo: this.$t('deviceMsg.issued'),
        progress: 0,
        hasError: false,
      });
      this.dosocketaction()
    },

    async onRequestCancelOta() {
      this.isLoadingReqCancelOta = true;

      const res = await StopOta({ 
        childDeviceIds: this.deviceModel.VDeviceId 
      })

      this.isLoadingReqCancelOta = false;

      if (res.StatusCode == this.$store.state.rightStatusCode) {
        this.stopOta();
      } else {
        alerterror(this, res.StatusCode);
      }
    },

    async onRequestImmediateOta(upOtaIndex) {
      await this.onRequestOta(upOtaIndex);
    },

    async onRequestAutoOta(upOtaIndex) {
      if (!this.versionList[upOtaIndex]) {
        console.error('onRequestAutoOta index error')
        return
      };
      const { otaStatus } = this.versionList[upOtaIndex]
      if (otaStatus === OTA_STATUS_ENUMS.PROCESSING) return

      this.otaSuccessHandled = false;

      const isAwake = this.isDeviceAwake;

      const params = {
        vDeviceId: this.deviceModel.VDeviceId,
        mode: 0,
        sourceType: this.versionList[upOtaIndex].SourceType,
        otaMode: 1,
        isCombineOta:false
      };

      this.isLoadingReqOta = true;
      const res = await StartCombineOta(params);
      this.isLoadingReqOta = false;

      if (res.StatusCode !== this.$store.state.rightStatusCode) {
        alerterror(this, res.StatusCode);
        return;
      }
      debugger
      this.upOtaIndex = upOtaIndex;

      setLocalStoragItem('upOtaDeviceInfo', JSON.stringify({
        VDeviceId: this.deviceModel.VDeviceId,
        upOtaIndex
      }));

      // 睡眠时仅下发指令，等设备唤醒后由 socket 推送进度
      if (!isAwake) {
        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PADDING,
          otaInfo: this.$t('deviceMsg.waitForupgrade'),
          progress: 0,
          hasError: false,
        });
        this.dosocketaction();
        return;
      }

      this.setCurrentFirmware({
        otaStatus: OTA_STATUS_ENUMS.PROCESSING,
        otaInfo: this.$t('deviceMsg.issued'),
        progress: 0,
        hasError: false,
      });

      this.dosocketaction();
    },

    async refreshDeviceAwakeState() {
      if (!this.useAsyncOtaUi) {
        this.isDeviceAwake = true;
        return { isAwake: true };
      }

      try {
        const res = await GetDeviceStatus({
          DeviceId: this.device.DeviceId
        });

        if (res.StatusCode !== this.$store.state.rightStatusCode || !res.Result) {
          this.isDeviceAwake = false;
          return { isAwake: false };
        }

        const result = JSON.parse(res.Result);
        const list = Array.isArray(result) ? result : [];

        // 0x150D：0-已唤醒，1-睡眠；无此状态字默认睡着
        const sleepItem = list.find(item => item.StatusType === '0x150D');
        if (sleepItem) {
          this.isDeviceAwake = sleepItem.Value === '0' || sleepItem.Value === 0;
        } else {
          this.isDeviceAwake = false;
        }

        return { isAwake: this.isDeviceAwake };
      } catch (err) {
        console.log('refreshDeviceAwakeState error', err);
        this.isDeviceAwake = false;
        return { isAwake: false };
      }
    },

    /* 
     * 停止ota升级
     */
    stopOta () {
      this.setCurrentFirmware({
        otaStatus: OTA_STATUS_ENUMS.STOP,
        otaInfo: '', // this.$t('deviceMsg.upgrade'),
        progress: 0,
        hasError: false,
      });
      this.removeSocket()
    },

     /* 移除单个socket信息
     */
     removeSocket() {
      if(this.deviceModel.DeviceId === undefined) return;
      postWebIOSocket('sync_info_remove_event', {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 6,
            id: this.deviceModel.DeviceId
          }
        ]
      })
    },
    /* 注册socket信息
     */
     dosocketaction () {
      if(this.deviceModel.DeviceId === undefined) return;
      postWebIOSocket('sync_info_add_event', {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 6,
            id: this.deviceModel.DeviceId
          }
        ]
      })
    },
    /**
     * 处理socket
     * @param res 
     */
    async handlerSocket(res) {
      // 组合升级由 OtaBind 独占处理，避免与父组件重复触发 otaSuccess
      if (this.isSupportBindOta === true) return;

      // console.log(`[socket]`, res);
      if (res.StatusCode !== this.$store.state.rightStatusCode || !res.Result) return;

      const Result = res.Result[0];
      const Type = Result.Type;
      // 只处理当前设备
      if (this.deviceModel.DeviceId !== Result.DeviceId) return;

      if (Type === 11) {
        // 升级过程离线
        this.handlerDeviceOnline(Result);
      }

      if (Type === 6) {
        this.handlerOtaSocket(Result);
      }
    },

    /**
     * 升级成功
     */
    async otaSuccess() {
      if (this.otaSuccessHandled) return;
      this.otaSuccessHandled = true;

      // 结束ota
      this.stopOta();

      success(this, this.$t('otatask.UpgradeSuccess'));

      // 版本数据同步有延时, 多同步几次版本数据
      await sleep(1.5 * 1000);

      
      for (let i = 0; i < 60; i++) {
        this.doOTAVersion();

        await sleep(3 * 1000);
      }
    },

    /**
     * 升级至一半设备离线
     * @param res 
     */
    handlerDeviceOnline(res) {
      console.log('更新进度', {
        Type: 11
      });

      const VDeviceId = res.VDeviceId;

      // 同一个设备才处理
      if (Number(VDeviceId) !== Number(this.deviceModel.VDeviceId)) return;

      const isOnlineData = (res.StatusInfo || []).find(item => item.StatusType === '0x0100') || { Value: 1 };
      const isOnline = Number(isOnlineData.Value) === 1;
      console.log('isOnlineData', isOnlineData, isOnline)
      // 升级过程离线
      if (
        !isOnline && 
        // !this.isloadingota && !this.isstop
        this.otaStatus === OTA_STATUS_ENUMS.PROCESSING
      ) {
        error(this, this.$t('deviceMsg.ingfail'));

        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PADDING,
          // otaStatus: OTA_STATUS_ENUMS.UPDATE_FAILED,
          otaInfo: this.$t('deviceMsg.ingfail'),
          hasError: true,
        })
        // this.stopOta();
      }
    },

    // ota升级信息
    async handlerOtaSocket(res) {
      const { MsgType } = res;
      const OpCode = Number(res.OpCode);
      const Progress = Number(res.Progress);
      
      console.log('更新进度', {
        OpCode,
        Progress,
        MsgType,
        Type: 6
      });

      // 正常情况
      if (OpCode === 0) {
        if (res.MsgType === '0x02660000') {
          // 界面点击取消 - 成功
          success(this, this.$t('deviceMsg.stopsuccess'));

          this.setCurrentFirmware({
            otaStatus: OTA_STATUS_ENUMS.PADDING,
            progress: 0,
            otaInfo: '',
            hasError: false,
          });
          // this.stopOta();

          return;
        }

        if (this.otaStatus === OTA_STATUS_ENUMS.STOP) {
          return;
        }

        this.setCurrentFirmware({
          otaStatus: OTA_STATUS_ENUMS.PROCESSING,
          progress: Progress,
          otaInfo: Progress > 0 ? this.$t('deviceMsg.upgrade') : this.$t('deviceMsg.issued'),
          hasError: false,
        });

         // 升级成功（防重入放在 otaSuccess 内，此处不可先置 otaSuccessHandled）
        if (Progress === 100) {
          await sleep(1.5 * 1000);
          this.otaSuccess();
        }
      }

      if (OpCode === 1) {
         // 0x020A0000 发起升级失败 0x02200000 升级中失败
        if (
          ['0x020A0000', '0x02200000'].includes(MsgType) &&
          this.otaStatus !== OTA_STATUS_ENUMS.STOP
        ) {
          this.setCurrentFirmware({
            // otaStatus: OTA_STATUS_ENUMS.UPDATE_FAILED,
            otaStatus: OTA_STATUS_ENUMS.PADDING,
            otaInfo: this.$t('deviceMsg.ingfail'),
            hasError: true,
          });

          warning(this, this.$t('deviceMsg.ingfail'));
        }

        // 界面点击取消 - 失败
        if (MsgType === '0x02660000') {
          this.setCurrentFirmware({
            // otaStatus: OTA_STATUS_ENUMS.CANCEL_FAILED,
            otaStatus: OTA_STATUS_ENUMS.PROCESSING,
            otaInfo: this.$t('deviceMsg.stopfail'),
            hasError: true,
          });

          warning(this, this.$t('deviceMsg.stopfail'))
        }        
      }

      const errorMsg = {
        4: this.$t('deviceMsg.UpgradeDuplicate'),
        21: this.$t('deviceMsg.UpgradeBusy'),
        22: this.$t('deviceMsg.UpgradeConfilct'),
        23: this.$t('deviceMsg.UpgradeProjectIdNull'),
        24: this.$t('deviceMsg.stopsuccess'),
        25: this.$t('deviceMsg.stopfail'),
      }

      if (
        [4, 21, 22, 23].includes(OpCode) && 
        this.otaStatus !== OTA_STATUS_ENUMS.STOP
      ) {
        this.setCurrentFirmware({
          // otaStatus: OTA_STATUS_ENUMS.UPDATE_FAILED,
          otaStatus: OTA_STATUS_ENUMS.PADDING,
          otaInfo: errorMsg[OpCode],
          hasError: true,
        });

        // this.stopOta();
        warning(this, errorMsg[OpCode]);
      }

      if (OpCode == 24) {
        this.setCurrentFirmware({
          // otaStatus: OTA_STATUS_ENUMS.CANCEL_FAILED,
          otaStatus: OTA_STATUS_ENUMS.PADDING,
          otaInfo: errorMsg[OpCode],
          hasError: false,
        });

        success(this, errorMsg[OpCode])
      }

      if (OpCode == 25) {
        this.setCurrentFirmware({
          // otaStatus: OTA_STATUS_ENUMS.CANCEL_FAILED,
          otaStatus: OTA_STATUS_ENUMS.PROCESSING,
          otaInfo: errorMsg[OpCode],
          hasError: true,
        });

        warning(this, errorMsg[OpCode])
      }
      // this.customColor = isError ? '#EE1111' : '';
    },

    //回调消息是否显示升级按钮
    showUpLevelBtn(info,index){
      this.versionList[index].cardStatus = info;
      this.$emit('showUpLevelBtn',this.versionList,this.device)
    },

    //一键升级回调方法
    oneUplevel(){
      for(let i =0 ;i< this.versionList.length;i++){
        const item = this.versionList[i];
        if(item.cardStatus && item.cardStatus.isShowStartBtn && !item.cardStatus.isStartDisabled){
          this.onRequestOta(i);
          break;
        }
      } 
    }
  }
}
</script>

<style lang="scss">
.opple-ota-cards {
  width: 100%;
  &_head {
    display: flex;
    justify-content: space-between;
    padding-bottom: 14px;

    &_gt {
      font-weight: 500;
      color: #0046AA;
      cursor: pointer;
    }
  }

  &_container {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    margin-bottom: 10px;
    -webkit-overflow-scrolling: touch;

    > .opple-ota-card {
      flex-shrink: 0;
    }

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.15);
      border-radius: 3px;
    }
  }
}
</style>
  